import gql from "graphql-tag";

export function GET_SHOP_INFO() {
  return gql`
    query GetShopInfo {
      shop {
        currencyCode
        billingAddress {
          countryCodeV2
        }
      }
    }
    `
}

export function CHECK_INSTALLATION() {
  return gql`
    query GetInstallStatus {
      installation @rest(type: "InstallStatus", path: "/authentication/install/discount-planner-by-productessentials", method: "GET") {
        Status
        RedirectUrl
      }
    }
  `;
}